export default __webpack_public_path__ + "static/meetup-0ff51bb390e55f3d7cc2acc1d4729fb8.svg";